import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Terminal from "../../src";

import dynamicList from "./commands/dynamic";
import staticList from "./commands/static";

document.title = "Dagm Ayalew | Terminal Portfolio";

const cmd = { dynamicList, staticList };
const config = {
  prompt: "dagm@portfolio:~$ ",
  version: "1.0.0",
  initialDirectory: "~",
  bootCmd: "intro",
  welcomeMessage:
    "Welcome to Dagm's terminal portfolio.",
  featuredCommands: ["guide", "about", "experience", "projects", "case-studies", "skills", "now", "hire", "resume", "gui"],
};

ReactDOM.render(
  <React.StrictMode>
    <Terminal className={"fade"} cmd={cmd} config={config} />
  </React.StrictMode>,
  document.querySelector("#demo"),
);

const fadeEl = document.querySelectorAll(".fade");
window.addEventListener("load", function () {
  fadeEl.forEach((e) => e.classList.add("in"));
});

window.addEventListener("beforeunload", function () {
  fadeEl.forEach((e) => e.classList.remove("in"));
});
